export enum ApiKeyTypeEnum {
  PK = 'PK',
  SK = 'SK'
}
